import _ from 'lodash';
import { Form } from 'src/app/shared/models/application/form';
import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { MemberEvaluatee } from './memberEvaluatee';
import { MemberEvaluationStatus } from './memberEvaluationStatus';
import { MemberEvaluator, MemberEvaluatorStatusType } from './memberEvaluator';

export class EvaluationForm {
  public form: Form;
  public questions: AttributeDefinition[] = [];
  public evaluator: MemberEvaluator;
  public evaluatees: MemberEvaluatee[] = [];

  get status(): MemberEvaluationStatus {
    return this.form.hasExpired
      ? MemberEvaluationStatus.Expired
      : this.evaluator.status == MemberEvaluatorStatusType.Invited
        ? MemberEvaluationStatus.ReadyToComplete
        : MemberEvaluationStatus.Complete;
  }

  get title(): string {
    return this.form?.displayTitle;
  }

  get hasIntroduction(): boolean {
    return !_.isEmpty(this.introduction);
  }

  get introduction(): string {
    return this.form?.introduction;
  }

  get hasConfirmation(): boolean {
    return !_.isEmpty(this.confirmation);
  }

  get confirmation(): string {
    return this.form?.confirmation;
  }

  get hasConfirmationTitle(): boolean {
    return !_.isNil(this.confirmationTitle);
  }

  get confirmationTitle(): string {
    return this.form?.confirmationTitle;
  }

  public static parse(data: any): EvaluationForm {
    if (!data) return null;
    let evalationForm = new EvaluationForm();
    Object.assign(evalationForm, data);
    evalationForm.form = Form.parse(data.form);
    evalationForm.questions = _.map(data.questions, (question) => {
      let q = AttributeDefinition.parse(question);
      q.conditions = question.conditions;
      return q;
    });
    evalationForm.evaluatees = _.map(data.evaluatees, (evaluatee) => {
      return MemberEvaluatee.parse(evaluatee);
    });
    return evalationForm;
  }
}
